// @ts-nocheck

import DraftInput from './draft-input';


export default DraftInput;
